import React from 'react';
import './Logo.css';

const Logo = ({ size = 'medium', className = '' }) => {
  const sizeClasses = {
    small: 'logo-small',
    medium: 'logo-medium',
    large: 'logo-large'
  };

  const logoSrc = '/logo.png';

  return (
    <div className={`logo ${sizeClasses[size]} ${className}`}>
      <img 
        src={logoSrc} 
        alt="Open Arms Healthcare Services" 
        className="logo-image"
      />
    </div>
  );
};

export default Logo;
